import React, { Component } from 'react';  
import Util from "../../util.js";
import { setStorage, getStorage, onMiniProgramDialog } from '../../common'; 
import { connect } from 'react-redux';
import { getPayAll, goLogin } from '../../getPay';
import { Picker, List, Toast } from 'antd-mobile/lib';
import NavigatorMain from '../NavigatorMain.js';
import { hashHistory } from 'react-router';
import ModalSelect from '../Modal/ModalSelect';
import NullView from "../NullView.js";
import CalculatorLine from "./CalculatorLine.js";
import {getCondition, clearYlJyEnd} from '../../action/investmentAction.js';
import { GuidePageType } from "../guidePage/index.js";
import Guide from '../guidePage';
import CacheHOC from "../HOC/StateCache.js"

class PensionCalculatorResult extends Component { 
  state = {
    addflag: false,
    planType: "每月投资方案",
    startNum: "沪深300，年化8%",
    nowMoney: null,
    nowYear: this.props.location.state ? this.props.location.state.theParams.theOutAge-this.props.location.state.theParams.theAge : null,
    lineArray: null,
    resultShow: false,
    modalFlag: false,
    jmContent: "",
    jmTitle: "",
    superFundName:''
  }
  componentWillMount() {
    window._czc.push(["_trackEvent", "华夏财富H5", "养老测算结果", "进入"]);
    document.getElementsByTagName('title')[0].innerHTML = "养老测算结果";
    let { theParams } = this.props.location.state;
    let { planType } = this.state;
    let code;
    let _year = new Date().getFullYear();
    if(_year - theParams.theAge > _year - theParams.theOutAge && _year - theParams.theAge <= 1969) {
      code = "SF1019"; 
    }else if(_year - theParams.theAge >= 1970 && _year - theParams.theAge <= 1979) {
      code = "SF1020"; 
    }else if(_year - theParams.theAge >= 1980 && _year - theParams.theAge <= 1989) {
      code = "SF1021"; 
    }else if(_year - theParams.theAge >= 1990) {
      code = "SF1013"; 
    }
    if(theParams.gap < 0) {
      this.getMoney(theParams.yqylj/2, 25, planType, this.state.startNum);
    }else {
      this.getMoney(theParams.gap, 25, planType, this.state.startNum);
    }
  }
  goBack = () => {
    window._czc.push(["_trackEvent", "华夏财富H5", "养老测算结果", "回退"]);
    hashHistory.goBack();
  }
  goInvestMain = () => {
    hashHistory.push({
      pathname: "/nullView"
    });
  }
  goDetail = () => {
    window._czc.push(["_trackEvent", "华夏财富H5", "养老测算结果", "组合详情"]);
    let { userHasInvested, inNeedUpdate, dispatch } = this.props;
    let { theParams } = this.props.location.state;
    let code;
    let _year = new Date().getFullYear();
    if(_year - theParams.theAge > _year - theParams.theOutAge && _year - theParams.theAge <= 1969) {
      code = "SF1019"; 
    }else if(_year - theParams.theAge >= 1970 && _year - theParams.theAge <= 1979) {
      code = "SF1020"; 
    }else if(_year - theParams.theAge >= 1980 && _year - theParams.theAge <= 1989) {
      code = "SF1021"; 
    }else if(_year - theParams.theAge >= 1990) {
      code = "SF1013"; 
    }
    hashHistory.push({
      pathname: "/SuperFundDetail",
      state:{
        superFundCode:code,
      },
      query: {
        superFundCode: code
      }
    });
  }
  goPayDetail = async (event) => {
    window._czc.push(["_trackEvent", "华夏财富H5", "养老测算结果", "一键投资"]);
    event.stopPropagation();
    let flagDigital=await getStorage('loginState');
    let _currentUserInfo = await getStorage('currentUserInfo');
    const isMiniProgram = onMiniProgramDialog(flagDigital!='0' && !_currentUserInfo.isRealName ? GuidePageType.OpenAccount : GuidePageType.Trade)
    if (isMiniProgram) return
    let {  dispatch } = this.props;
    let route=window.history.length;
    let { theParams } = this.props.location.state;
    let code, name;
    let _year = new Date().getFullYear();
    if(_year - theParams.theAge > _year - theParams.theOutAge && _year - theParams.theAge <= 1969) {
      code = "SF1019";
      name = "60后智享财富组合";
    }else if(_year - theParams.theAge >= 1970 && _year - theParams.theAge <= 1979) {
      code = "SF1020";
      name = "70后智赢人生组合";
    }else if(_year - theParams.theAge >= 1980 && _year - theParams.theAge <= 1989) {
      code = "SF1021";
      name = "80后智领未来组合";
    }else if(_year - theParams.theAge >= 1990) {
      code = "SF1013";
      name = "90后智享自由组合";
    }
    let data={superFundCode:code}
    const fun=function(){   
      let params={
        fundCode:code,
        fundName:name,
        productType: "Z",
        pageText: "申购",
        superTypeValue: "0"
      }
      getPayAll(route,params,hashHistory,'PaymentAllSuperFund')
    }
    goLogin(fun,window.history.length);
  }
  ok(){
    hashHistory.push({
        pathname:'/paymentSuperFund',
    })
  }
  getMoney = (yearGap, N, planType, startNum) => {
    this.setState({
      lineArray: null
    });
    let thisO = this;
    setTimeout(() => {
      let { nowYear } = thisO.state;
      let r = 0.03;
      let r2 = 1/(1+r);
      let totalGap = yearGap * ((1-Math.pow((r2), N)) / (1-(r2)));
      let rate;
      if(planType == "每月投资方案") {
        if(startNum == "沪深300，年化8%") {
          rate = Math.pow ( (0.08+1), 1/12) -1;
        }else if(startNum == "中债综合财富指数，年化4.2%") {
          rate = Math.pow ( (0.042+1), 1/12) -1;
        }else if(startNum == "标普500，年化7%") {
          rate = Math.pow ( (0.07+1), 1/12) -1;
        }
        thisO.PMT(rate, nowYear*12, 0, totalGap);
      }else if(planType == "一次投资方案") {
        if(startNum == "沪深300，年化8%") {
          rate = 0.08;
        }else if(startNum == "中债综合财富指数，年化4.2%") {
          rate = 0.042;
        }else if(startNum == "标普500，年化7%") {
          rate = 0.07;
        }
        thisO.PV(rate, nowYear, totalGap);
      }
    });
  } 
  PMT = (ir, np, pv, fv ) => {
   var pmt = ( ir * ( pv * Math.pow ( (ir+1), np ) + fv ) ) / ( ( ir + 1 ) * ( Math.pow ( (ir+1), np) -1 ) );
   this.setState({
    nowMoney: pmt.toFixed(2)
   });
   this.getProfitCurve4PMT(pmt, np, ir);
  }

  PV = (ir, np, fv) => {
    var pv = fv / (Math.pow((1+ir), np));
    this.setState({
      nowMoney: pv.toFixed(2)
    });
    this.getProfitCurve4PV(pv, np, ir);
  }

  getProfitCurve4PV = (pv, n, r) => { 
    let c = []; 
    for(let i=0; i<=n; i++) { 
      c[i] = (pv * Math.pow((1+r), i)*0.0001).toFixed(2); 
    } 
    this.setState({
      lineArray: c
    });
  }

  getProfitCurve4PMT = (pmt, n, r) => { 
    let c = []; 
    for(let i=0; i<=n; i++){ 
      if(i===0) { 
        c[i] = (pmt*0.0001).toFixed(2); 
      }
      else {
        c[i] = (c[i-1]*(1+r) + pmt*0.0001).toFixed(2); 
      } 
    }
    this.setState({
      lineArray: c
    });
  }

  changeStartNum = (value) => {
    let { theParams } = this.props.location.state;
    let { planType } = this.state;
    this.setState({
      startNum: value[0]
    });
    if(theParams.gap < 0) {
      this.getMoney(theParams.yqylj/2, 25, planType, value);
    }else {
      this.getMoney(theParams.gap, 25, planType, value);
    }
  }

  changePlan = (value) => {
    window._czc.push(["_trackEvent", "华夏财富H5", "养老测算结果", "选择方案"]);
    let { theParams } = this.props.location.state;
    this.setState({
      planType: value
    });
    if(theParams.gap < 0) {
      this.getMoney(theParams.yqylj/2, 25, value, this.state.startNum);
    }else {
      this.getMoney(theParams.gap, 25, value, this.state.startNum);
    }
  }
  closeModal = () => {
    this.setState({
      modalFlag: false
    });
    let obj = document.getElementsByTagName("html")[0];
    obj.style.overflowY = "auto";
    obj.style.overflowY = "auto";
    obj.removeEventListener("touchmove", this.touchMove, false);
  }
  showModal = (value) => {
    let { theParams } = this.props.location.state;
    if(value == "0") {
      this.setState({
        modalFlag: true,
        jmTitle: "查理解密",
        jmContent: "可支取的养老金是根据您当前实际的养老储备金和年龄，计算出当您达到" + theParams.theOutAge + "岁退休年龄时，每月可支取的养老金。"
      });
    }else if(value == "1") {
      this.setState({
        modalFlag: true,
        jmTitle: "查理解密",
        jmContent: "查理智投暂时还不支持组合定投业务，您需要通过每月主动投资来完成该投资方案。"
      });
    }else if(value == "2") {
      this.setState({
        modalFlag: true,
        jmTitle: "查理解密",
        jmContent: "参考指数的年化收益是根据2002年至2017年期间的指数表现，取5年滚动收益序列求平均值，然后进行年化处理所得。"
      });
    }
    let obj = document.getElementsByTagName("html")[0];
    obj.style.overflowY = "hidden";
    obj.style.overflowY = "hidden";
    obj.addEventListener("touchmove", this.touchMove, false);
  }
  touchMove = (event) => {
    event.preventDefault();
  }
  componentWillUnmount() {
    window._czc.push(["_trackEvent", "华夏财富H5", "养老测算结果", "退出"]);
    Guide.leave();
  }
  goDT = async (event) => {
    event.stopPropagation();
    let flagDigital=await getStorage('loginState');
    let _currentUserInfo = await getStorage('currentUserInfo');
    const isMiniProgram = onMiniProgramDialog(flagDigital!='0' && !_currentUserInfo.isRealName ? GuidePageType.OpenAccount : GuidePageType.Trade)
    if (isMiniProgram) return
    let { theParams } = this.props.location.state;
    let code, name;
    let _year = new Date().getFullYear();
    if(_year - theParams.theAge > _year - theParams.theOutAge && _year - theParams.theAge <= 1969) {
      code = "SF1019";
      name = "60后智享财富组合";
    }else if(_year - theParams.theAge >= 1970 && _year - theParams.theAge <= 1979) {
      code = "SF1020";
      name = "70后智赢人生组合";
    }else if(_year - theParams.theAge >= 1980 && _year - theParams.theAge <= 1989) {
      code = "SF1021";
      name = "80后智领未来组合";
    }else if(_year - theParams.theAge >= 1990) {
      code = "SF1013";
      name = "90后智享自由组合";
    }
    let params = {
      fundCode: code,
      fundName: name,
      productType: "Z",
      pageText: "新建定投计划",
      superTypeValue: "0",
      text:this.state.nowMoney!=null?this.state.nowMoney:''
    }
    getPayAll( window.history.length, params, hashHistory, 'PaymentAllSuperFund')
  }
  render() { 
    let { theParams } = this.props.location.state;
    let { planType, startNum, nowYear, nowMoney, lineArray, jmContent, jmTitle } = this.state;
    let startNumArray = [{value: "沪深300，年化8%", label: "沪深300，年化8%"}, {value: "中债综合财富指数，年化4.2%", label: "中债综合财富指数，年化4.2%"}, {value: "标普500，年化7%", label: "标普500，年化7%"}];
    let textList = [];
    let _year = new Date().getFullYear();
    if(_year - theParams.theAge > _year - theParams.theOutAge && _year - theParams.theAge <= 1969) {
      textList.push(
        <div key={0} style={{fontSize: 18, color: "#fa063a"}}>{"60后智享财富组合"}</div>
      );
    }else if(_year - theParams.theAge >= 1970 && _year - theParams.theAge <= 1979) {
      textList.push(
        <div key={0} style={{fontSize: 18, color: "#fa063a"}}>{"70后智赢人生组合"}</div>
      );
    }else if(_year - theParams.theAge >= 1980 && _year - theParams.theAge <= 1989) {
      textList.push(
        <div key={0} style={{fontSize: 18, color: "#fa063a"}}>{"80后智领未来组合"}</div>
      );
    }else if(_year - theParams.theAge >= 1990) {
      textList.push(
        <div key={0} style={{fontSize: 18, color: "#fa063a"}}>{"90后智享自由组合"}</div>
      );
    }
    return (  
      <div className="mainBox"> 
      <ModalSelect go={()=>this.ok()} />
        <NavigatorMain>
          <div className="boxHeader bgChange">
            <div>
              <img onClick={this.goBack} src={require("../../img/leftArrow_header.png")} />
            </div>
            <div>
              <span>养老测算结果</span>
            </div>
            <div>
              <span onClick={this.goInvestMain}>跳过</span>
            </div>
          </div>
        </NavigatorMain> 
        <div className="boxContent" id='PensionCalculatorResultIndex' style={{paddingBottom:74,display:'flex',flex:1,overflowY:'scroll',flexDirection:'column'}}>
          <div  className="bgChange2" style={{backgroundSize: "cover",width: window.winWidth, height: "auto", paddingBottom: 20, paddingTop: 20}}>
            <div style={{
              width: window.winWidth,
              paddingLeft: 13,
              paddingRight: 13,
              WebkitFlexDirection: "row",
              WebkitJustifyContent: "space-between",
              WebkitAlignItems: "center",
              display: "-webkit-flex"
            }}>
              <img
              style={{width: 63, height: 63}}
              src={require("../../img/jqrIcon.png")}
              />
              <div style={{paddingRight: 10, paddingTop: 10, paddingBottom: 10, paddingLeft: 15, backgroundColor: "rgba(0, 0, 0, 0.2)", width: window.winWidth-96, borderRadius: 10}}>
                <span style={{
                  color: "#fff",
                  lineHeight: "16px",
                  fontSize: 13
                }}>{theParams.gap <= 0 ? "根据测算，您目前的养老储蓄已可以满足您的需求。为了给您将来的生活提供更好的保障，为您专属定制了养老智投组合投资方案：" : "根据测算，您目前的养老储蓄和您期望的美好生活还存在较大差距，建议您提早投资，增加养老金储备。为您专属定制了养老智投组合投资方案：" }</span>
              </div> 
            </div>
          </div>
          <div>
            <div style={{backgroundColor: "#fff", WebkitFlexDirection: 'row', WebkitJustifyContent: "space-around", paddingTop: 20, paddingBottom: 20, borderBottom: "1px solid rgb(235, 238, 240)", display: "-webkit-flex"}}>
              <div style={{WebkitAlignItems: "center", display: "-webkit-flex", WebkitFlexDirection: "column"}}>
                <div style={{marginBottom: 5, position: "relative"}}>
                  <div  style={{color: "#5b6370", fontSize: 13}}>可支取的养老金</div>
                  <div onClick={() => {this.showModal("0")}} style={{position: "absolute", width: 35, height: 35, right: -40, top: -10, WebkitJustifyContent: "center", WebkitAlignItems: "center", display: "-webkit-flex"}}>
                    <img src = {require('../../img/wenhao.png')} style={{width: 15, height: 15}} />
                  </div>
                </div>
                <div  style={{fontSize: 22, color: "#3a3e47", marginTop: 5}}>{Util.parsePrice(theParams.actual/12, false)}<span  style={{fontSize: 13, color: "#5b6370"}}> 元／月</span></div>
              </div>
              <div style={{height: 50, width: 1, backgroundColor: "rgb(235, 238, 240)"}}></div>
              <div style={{WebkitAlignItems: "center", display: "-webkit-flex", WebkitFlexDirection: "column"}}>
                <div style={{marginBottom: 5}}>
                  <span  style={{color: "#5b6370", fontSize: 13}}>养老金缺口</span>
                </div>
                <div  style={{fontSize: 22, color: "#fa063a", marginTop: 5}}>{theParams.gap < 0 ? 0 : Util.parsePrice(theParams.gap/12, false)}<span  style={{fontSize: 13, color: "#5b6370"}}> 元／月</span></div>
              </div>
            </div>
            <div style={{
              display: "-webkit-flex",
              height: 45,
              backgroundColor: "#fff",
              paddingLeft: 13,
              paddingRight: 13,
              WebkitAlignItems: "center",
              WebkitFlexDirection: "row",
              borderBottom: "1px solid rgb(255, 238, 240)"
            }}>
              <span style={{
                color: "#5b6370",
                fontSize: "13px",
                width: "50%"
              }}>
                期望获得的养老金
              </span>
              <span style={{
                color: "#5b6370",
                fontSize: "13px",
                width: "50%",
                textAlign: "right"
              }}>
                {theParams.theMoney}<span style={{fontSize: "13px", color: "#5b6370"}}>元／月</span>
              </span>
            </div>
          </div>
          <div style={{display: "-webkit-flex", height: 45, width: window.winWidth, WebkitFlexDirection: "row", border: "1px solid #ebedf0", backgroundColor: "#fff", marginTop: 10}}>
            <div onClick={() => this.changePlan("每月投资方案")} style={planType == "每月投资方案" ? {borderBottom: "1px solid #ff9a96",width: "50%", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"} : {width: "50%", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
              <span style={planType == "每月投资方案" ? {color: "#3a3e47", fontSize: 13} : {color: "#5b6370", fontSize: 13}}>每月投资方案</span>
            </div>
            <div onClick={() => this.changePlan("一次投资方案")} style={planType == "一次投资方案" ? {borderBottom: "1px solid #ff9a96",width: "50%", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"} : {width: "50%", display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
              <span style={planType == "一次投资方案" ? {color: "#3a3e47", fontSize: 13} : {color: "#5b6370", fontSize: 13}}>一次投资方案</span>
            </div>
          </div>
          <div>
            <div style={{backgroundColor: "#fff", WebkitFlexDirection: 'row', WebkitJustifyContent: "space-around", paddingTop: 20, paddingBottom: 20, borderBottom: "1px solid rgb(235, 238, 240)", display: "-webkit-flex"}}>
              <div style={{textAlign: "center"}}>
                <div  style={{marginBottom: 5, color: "#5b6370", fontSize: 13, position: "relative"}}>{planType == "每月投资方案" ? "每月投入" : "一次性投入"}
                  {
                    planType == "每月投资方案" ? 
                    <div onClick={() => {this.showModal("1")}} style={{position: "absolute", width: 35, height: 35, right: -30, top: -10, WebkitJustifyContent: "center", WebkitAlignItems: "center", display: "-webkit-flex"}}>
                      <img src = {require('../../img/wenhao.png')} style={{width: 15, height: 15}} />
                    </div>
                    :
                    null
                  }
                </div>
                <div  style={{fontSize: 22, color: "#3a3e47", marginTop: 5}}>{nowMoney != null ? Util.parsePrice(nowMoney, false) : null}<span  style={{fontSize: 13, color: "#5b6370"}}> {nowMoney != null ? "元" : null}</span></div>
              </div>
              <div style={{height: 50, width: 1, backgroundColor: "rgb(235, 238, 240)"}}></div>
              <div style={{divAlign: "center"}}>
                <div  style={{marginBottom: 5, color: "#5b6370", fontSize: 13}}>持续投资</div>
                <div  style={{fontSize: 22, color: "#3a3e47", marginTop: 5}}>{nowYear}<span  style={{fontSize: 13, color: "#5b6370"}}> 年</span></div>
              </div>
              <div style={{height: 50, width: 1, backgroundColor: "rgb(235, 238, 240)"}}></div>
              <div style={{WebkitAlignItems: "center"}}>
                <div  style={{marginBottom: 5, color: "#5b6370", fontSize: 13}}>可新增养老金</div>
                <div  style={{fontSize: 22, color: "#fa063a", marginTop: 5}}>{theParams.gap < 0 ? Util.parsePrice(Math.round(Number(theParams.yqylj/2/12))*10000,false) : lineArray != null ? Util.parsePrice(Math.round(Number(lineArray[lineArray.length - 1]))*10000,false) : null}<span  style={{fontSize: 13, color: "#5b6370"}}> 元</span></div>
              </div>
            </div>
            {
              lineArray != null ? 
              <CalculatorLine dataSource={lineArray} planType={planType} nowYear={nowYear} /> : 
              null
            }
            <div className="pickerBox" style={{
              display: "-webkit-flex",
              height: 45,
              borderTop: "1px solid rgb(235, 238, 240)",
              WebkitJustifyContent: "space-between",
              WebkitAlignItems: "center",
              WebkitFlexDirection: "row",
              paddingLeft: 13,
              paddingRight: 5,
              backgroundColor: "#fff",
              position: 'relative'
            }}>
              <Picker value={[startNum]} title="计算参考指数" extra={startNum} data={startNumArray} onChange={this.changeStartNum} cols={1} className="forss">
                <List.Item arrow="horizontal">选择参考指数</List.Item>
              </Picker>
              <div onClick={() => {this.showModal("2")}} style={{position: "absolute", width: 35, height: 35, left: 90, WebkitJustifyContent: "center", WebkitAlignItems: "center", display: "-webkit-flex"}}>
                <img src = {require('../../img/wenhao.png')} style={{width: 15, height: 15}} />
              </div>
            </div>
          </div>
          <div style={{paddingLeft: 13, paddingRight: 13, paddingTop: 10, paddingBottom: 10, backgroundColor: "#fff", marginTop: 10, marginBottom: 10}}>
            <span style={{fontSize: 13, color: "#5b6370", marginTop: 5, lineHeight: "20px", fontWeight: "bold"}}>温馨提示 : {/*投资方案为结合市场中代表性指数过去5年业绩进行计算的，试算结果并不代表您实际投资能够得到的收益。*/}上述模拟使用市场中代表性指数过去5年的年化平均收益率计算，未来由于市场环境不同、实际投资运作等不可能完全复制该模拟结果。该模拟不能作为投资预测，也不代表您实际投资所得收益，投资也可能遭遇亏损。</span>
          </div>
        </div>
        <div onClick={this.goDetail} style={{position: "fixed", bottom: 0, width: "100%", zIndex: 99999990, height: 74, backgroundColor: "#fff", paddingTop: 10, paddingBottom: 10, WebkitFlexDirection: "row", borderTop: "1px solid #e1e3e6", display: "-webkit-flex", WebkitAlignItems: "center"}}>
          <div style={{WebkitFlex: 0.6, paddingLeft: 13, WebkitJustifyContent: "flex-start", display: "-webkit-flex", WebkitFlexDirection: "column"}}>
            {
              textList
            }
            <div style={{fontSize: 13, color: "#000", marginTop: 5}}>市场有风险，投资需谨慎</div>
          </div>
          <div style={{WebkitFlex: 0.4, WebkitJustifyContent: "flex-end", WebkitAlignItems: "flex-end", paddingRight: 13, display: "-webkit-flex"}}>
            {
              planType == "每月投资方案" ?<div onClick={this.goDT} style={{backgroundColor: "#fa063a", height: 35, width: 130, border: "1px solid #fa063a", borderRadius: 20, WebkitJustifyContent: "center", WebkitAlignItems: "center", display: "-webkit-flex"}}>
                <span style={{fontSize: 18, color: "#fff"}}>一键定投</span>
              </div>:<div onClick={this.goPayDetail} style={{backgroundColor: "#fa063a", height: 35, width: 130, border: "1px solid #fa063a", borderRadius: 20, WebkitJustifyContent: "center", WebkitAlignItems: "center", display: "-webkit-flex"}}>
                <span style={{fontSize: 18, color: "#fff"}}>一键投资</span>
              </div>
            }
          </div>
        </div>
        {
          this.state.modalFlag ? <div style={{width: window.winWidth, bottom: 0, backgroundColor: "rgba(0, 0, 0, 0.5)", WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", position: "fixed", left: 0, top: 0, zIndex: 99999999, display: "-webkit-flex"}}>
            <div style={{WebkitFlexDirection: "column",  width: 300, backgroundColor: "#fff", borderRadius: 20, WebkitAlignItems: "center", display: "-webkit-flex"}}>
              <div style={{display: "-webkit-flex", WebkitFlex: 1, WebkitAlignItems: "center",  WebkitFlexDirection: "column"}}>
                <span style={{fontSize: 16, marginTop: 20, lineHeight: "22px", color: "#333333",fontWeight:"500",paddingLeft: 20, paddingRight: 20,}}>{jmContent}</span>
                <div onClick={this.closeModal} style={{ width:"100%", height:"40px", textAlign:"center", lineHeight:"40px",borderTopColor:"#ebeef0",borderTopWidth:"1px",borderTopStyle:"solid",marginTop:"15px"}}>
                  <div style={{WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center", display: "-webkit-flex", height: "100%"}}>
                    <span style={{fontSize:17,color:'#666666'}}>知道了</span>
                  </div>
                </div> 
              </div>
            </div>           
          </div> : null
        }
      </div>  
    );  
  }  
}  
  
function mapStateToProps(state, ownProps) {
  return {
   userHasInvested:state.userHasInvested,
   inNeedUpdate:state.inNeedUpdate
  }
}

export default connect(mapStateToProps)(CacheHOC(PensionCalculatorResult,'PensionCalculatorResultIndex'));




// WEBPACK FOOTER //
// ./src/components/recommend/PensionCalculatorResult.js